/**
 * resource-admin 子应用中文国际化文案
 *
 * 从 skeleton/resource-admin/src/i18n/locales/zh.json 迁移到 Umi Max locale 格式
 * 使用扁平 key 格式（点号分隔），符合 Umi Max locale 插件规范
 *
 * Requirements: 10.5, 10.6
 */
export default {
  // ============== common 通用 ==============
  'common.actions': '操作',
  'common.view': '查看',
  'common.edit': '编辑',
  'common.delete': '删除',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.create': '创建',
  'common.new': '新建',
  'common.tree': '树形',
  'common.submit': '提交',
  'common.next': '下一步',
  'common.previous': '上一步',
  'common.back': '返回',
  'common.backToList': '返回列表',
  'common.confirm': '确认',
  'common.close': '关闭',
  'common.retry': '重试',
  'common.refresh': '刷新',
  'common.search': '搜索',
  'common.filter': '筛选',
  'common.clear': '清除',
  'common.apply': '应用',
  'common.reset': '重置',
  'common.loading': '加载中...',
  'common.saving': '保存中...',
  'common.submitting': '提交中...',
  'common.initializing': '初始化中...',
  'common.processing': '处理中...',
  'common.deleting': '删除中...',
  'common.updating': '更新中...',
  'common.creating': '创建中...',
  'common.noData': '暂无数据',
  'common.noResults': '未找到结果',
  'common.yes': '是',
  'common.no': '否',
  'common.active': '启用',
  'common.inactive': '停用',
  'common.optional': '可选',
  'common.required': '此项为必填项',
  'common.deleteSuccess': '删除成功',
  'common.deleteFailed': '删除失败',
  'common.createSuccess': '创建成功',
  'common.createFailed': '创建失败',
  'common.updateSuccess': '更新成功',
  'common.updateFailed': '更新失败',
  'common.deleteConfirm': '确定要删除吗？',

  // ============== menus 菜单管理 ==============
  'menus.title': '菜单管理',
  'menus.create': '新建菜单',
  'menus.createFirst': '创建第一个菜单',
  'menus.createTitle': '新建菜单',
  'menus.createDescription': '创建新菜单及其操作和路由',
  'menus.editTitle': '编辑菜单',
  'menus.editDescription': '更新菜单信息、操作和路由',
  'menus.viewTitle': '菜单详情',
  'menus.viewDescription': '查看菜单详情、操作和路由',
  'menus.menuInformation': '菜单信息',
  'menus.menuInformationDescription': '基本菜单属性和配置',
  'menus.typeOptions.group': '分组',
  'menus.typeOptions.menu': '菜单',
  'menus.typeOptions.divider': '分隔线',
  'menus.actions': '操作',
  'menus.actionsDescription': '此菜单的权限控制操作',
  'menus.routes': '路由',
  'menus.routesDescription': '与此菜单关联的 HTTP API 端点',
  'menus.addAction': '添加操作',
  'menus.addRoute': '添加路由',
  'menus.removeAction': '移除操作',
  'menus.removeRoute': '移除路由',
  'menus.noActions': '未配置操作',
  'menus.noRoutes': '未配置路由',
  'menus.externalLink': '外部链接',
  'menus.internalLink': '内部链接',
  'menus.noParent': '无父菜单（根菜单）',
  'menus.selectParent': '选择父菜单',
  'menus.deleteConfirmTitle': '删除菜单',
  'menus.deleteConfirmDescription': '确定要删除 "{name}" 吗？此操作无法撤销。',

  // menus fields
  'menus.fields.id': '菜单 ID',
  'menus.fields.name': '菜单名称',
  'menus.fields.type': '类型',
  'menus.fields.url': 'URL',
  'menus.fields.icon': '图标',
  'menus.fields.serialNumber': '排序号',
  'menus.fields.parentMenu': '父菜单',
  'menus.fields.externalLink': '外部链接',
  'menus.fields.status': '状态',
  'menus.fields.cache': '缓存',
  'menus.fields.component': '组件路径',
  'menus.fields.partName': '部件名称',
  'menus.fields.level': '层级',
  'menus.fields.leaf': '是否叶子节点',
  'menus.fields.code': '编码',
  'menus.fields.resourceId': '所属资源',
  'menus.fields.actionCode': '操作代码',
  'menus.fields.actionName': '操作名称',
  'menus.fields.actionGroup': '操作分组',
  'menus.fields.actionDescription': '操作描述',
  'menus.fields.actionSerialNumber': '操作序号',
  'menus.fields.routeName': '路由名称',
  'menus.fields.routePath': '路由路径',
  'menus.fields.routeMethod': 'HTTP 方法',

  // menus placeholders
  'menus.fields.namePlaceholder': '请输入菜单名称',
  'menus.fields.urlPlaceholder': '请输入菜单 URL',
  'menus.fields.iconPlaceholder': '请输入图标名称',
  'menus.fields.codePlaceholder': '请输入菜单编码',
  'menus.fields.typePlaceholder': '请选择类型',
  'menus.fields.resourceIdPlaceholder': '请选择所属资源',
  'menus.fields.parentMenuPlaceholder': '请选择父菜单（可选）',
  'menus.fields.serialNumberPlaceholder': '请输入排序号',
  'menus.fields.componentPlaceholder': '请输入组件路径',
  'menus.fields.partNamePlaceholder': '请输入部件名称',
  'menus.fields.actionCodePlaceholder': 'menu:action',
  'menus.fields.actionNamePlaceholder': '操作名称',
  'menus.fields.actionGroupPlaceholder': 'menu',
  'menus.fields.actionDescriptionPlaceholder': '描述此操作的功能',
  'menus.fields.actionSerialNumberPlaceholder': '1',
  'menus.fields.routeNamePlaceholder': '获取项目',
  'menus.fields.routePathPlaceholder': '/api/v1/items',
  'menus.fields.routeMethodPlaceholder': 'GET',

  // menus status options
  'menus.statusOptions.enabled': '启用',
  'menus.statusOptions.disabled': '停用',

  // menus success/error messages
  'menus.success.created': '菜单创建成功',
  'menus.success.updated': '菜单更新成功',
  'menus.success.deleted': '菜单删除成功',
  'menus.error.notFound': '未找到菜单',
  'menus.error.noResourceId': '资源 ID 为必填项',
  'menus.error.loadFailed': '加载菜单详情失败',
  'menus.error.createFailed': '创建菜单失败',
  'menus.error.updateFailed': '更新菜单失败',
  'menus.error.deleteFailed': '删除菜单失败',

  // ============== roles 角色管理 ==============
  'roles.title': '角色管理',
  'roles.description': '管理角色和权限',
  'roles.create': '新建角色',
  'roles.createTitle': '新建角色',
  'roles.createDescription': '添加新的角色及权限',
  'roles.editTitle': '编辑角色',
  'roles.editDescription': '更新角色信息',
  'roles.viewTree': '查看角色树',
  'roles.treeTitle': '角色层级',
  'roles.treeDescription': '以树形结构查看角色层级关系',
  'roles.application': '应用',
  'roles.createSuccess': '角色创建成功',
  'roles.updateSuccess': '角色更新成功',
  'roles.deleteSuccess': '角色删除成功',
  'roles.statusUpdateSuccess': '角色状态更新成功',
  'roles.deleteConfirmTitle': '删除角色',
  'roles.deleteConfirmDescription': '确定要删除此角色吗？此操作无法撤销。',
  'roles.searchPlaceholder': '按名称搜索角色...',
  'roles.notFound': '未找到角色',
  'roles.noRoles': '未找到角色',
  'roles.name': '角色名称',
  'roles.code': '角色编码',
  'roles.parentRole': '父角色',
  'roles.noParentRole': '无父角色（根角色）',
  'roles.status': '状态',
  'roles.createdAt': '创建时间',
  'roles.updatedAt': '更新时间',
  'roles.id': 'ID',
  'roles.enable': '启用',
  'roles.disable': '停用',
  'roles.namePlaceholder': '请输入角色名称',
  'roles.codePlaceholder': '请输入角色编码',
  'roles.codeHelpText': '角色的唯一标识符（仅限字母、数字、下划线和连字符）',
  'roles.descriptionPlaceholder': '请输入角色描述',
  'roles.parentRolePlaceholder': '请选择父角色（可选）',
  'roles.parentRoleHelpText': '选择父角色以创建层级结构',
  'roles.basicInformation': '基本信息',
  'roles.statusOptions.enabled': '启用',
  'roles.statusOptions.disabled': '停用',

  // ============== resources 资源管理 ==============
  'resources.title': '资源管理',
  'resources.description': '描述',
  'resources.create': '新建资源',
  'resources.createTitle': '新建资源',
  'resources.createDescription': '添加新的后端资源',
  'resources.editTitle': '编辑资源',
  'resources.editDescription': '更新资源信息',
  'resources.createSuccess': '资源创建成功',
  'resources.updateSuccess': '资源更新成功',
  'resources.deleteSuccess': '资源删除成功',
  'resources.deleteConfirmTitle': '删除资源',
  'resources.deleteConfirmDescription': '确定要删除此资源吗？此操作无法撤销。',
  'resources.searchPlaceholder': '按名称搜索资源...',
  'resources.information': '资源信息',
  'resources.menuStructure': '菜单结构',
  'resources.noDescription': '暂无描述',
  'resources.noMenus': '此资源未配置菜单',
  'resources.empty': '暂无可用资源',
  'resources.emptyHint': '资源是提供功能的后端服务',
  'resources.fields.id': '资源 ID',
  'resources.fields.name': '资源名称',
  'resources.fields.type': '资源类型',
  'resources.fields.typeId': '类型 ID',
  'resources.fields.description': '描述',
  'resources.fields.namePlaceholder': '请输入资源名称',
  'resources.fields.typeIdPlaceholder': '请输入资源类型 ID',
  'resources.fields.typePlaceholder': '请选择资源类型',
  'resources.fields.descriptionPlaceholder': '请输入资源描述',
  'resources.error.loadFailed': '加载资源失败',
  'resources.error.notFound': '未找到资源',

  // ============== resourceTypes 资源类型管理 ==============
  'resourceTypes.title': '资源类型管理',
  'resourceTypes.description': '管理资源类型，用于分类和组织资源',
  'resourceTypes.create': '新建资源类型',
  'resourceTypes.createTitle': '新建资源类型',
  'resourceTypes.createDescription': '添加新的资源类型分类',
  'resourceTypes.editTitle': '编辑资源类型',
  'resourceTypes.editDescription': '更新资源类型信息',
  'resourceTypes.createSuccess': '资源类型创建成功',
  'resourceTypes.updateSuccess': '资源类型更新成功',
  'resourceTypes.deleteSuccess': '资源类型删除成功',
  'resourceTypes.deleteConfirmTitle': '删除资源类型',
  'resourceTypes.deleteConfirmDescription':
    '确定要删除此资源类型吗？此操作无法撤销。',
  'resourceTypes.searchPlaceholder': '按名称搜索资源类型...',
  'resourceTypes.empty': '暂无资源类型',
  'resourceTypes.emptyHint': '资源类型用于分类和组织后端资源',
  'resourceTypes.fields.id': '资源类型 ID',
  'resourceTypes.fields.name': '类型名称',
  'resourceTypes.fields.namePlaceholder': '请输入类型名称',
  'resourceTypes.error.loadFailed': '加载资源类型失败',
  'resourceTypes.error.notFound': '未找到资源类型',

  // ============== tenants 租户管理 ==============
  'tenants.title': '租户管理',
  'tenants.description': '管理租户组织及其配置',
  'tenants.create': '新建租户',
  'tenants.register': '注册租户',
  'tenants.createTitle': '新建租户',
  'tenants.createDescription': '向平台添加新的租户组织',
  'tenants.editTitle': '编辑租户',
  'tenants.editDescription': '更新租户信息',
  'tenants.createSuccess': '租户创建成功',
  'tenants.updateSuccess': '租户更新成功',
  'tenants.deleteSuccess': '租户删除成功',
  'tenants.deleteConfirmTitle': '删除租户',
  'tenants.deleteConfirmDescription': '确定要删除此租户吗？此操作无法撤销。',
  'tenants.searchPlaceholder': '按名称搜索租户...',
  'tenants.notFound': '未找到租户',
  'tenants.name': '租户名称',
  'tenants.logo': 'Logo',
  'tenants.address': '地址',
  'tenants.status': '状态',
  'tenants.createdAt': '创建时间',
  'tenants.updatedAt': '更新时间',
  'tenants.id': 'ID',
  'tenants.namePlaceholder': '请输入租户名称',
  'tenants.logoPlaceholder': '请输入 Logo 图片地址',
  'tenants.logoHelpText': '输入租户 Logo 的有效 URL',
  'tenants.logoPreview': 'Logo 预览',
  'tenants.addressPlaceholder': '请输入地址',
  'tenants.basicInformation': '基本信息',
  'tenants.statistics': '统计信息',
  'tenants.applicationCount': '应用数量',
  'tenants.viewApplications': '查看应用',
  'tenants.statusOptions.active': '启用',
  'tenants.statusOptions.inactive': '停用',

  // ============== applications 应用管理 ==============
  'applications.title': '应用管理',
  'applications.description': '管理应用及其域名绑定',
  'applications.create': '新建应用',
  'applications.createTitle': '新建应用',
  'applications.createDescription': '添加新应用并配置域名绑定',
  'applications.editTitle': '编辑应用',
  'applications.editDescription': '更新应用信息和域名',
  'applications.createSuccess': '应用创建成功',
  'applications.updateSuccess': '应用更新成功',
  'applications.deleteSuccess': '应用删除成功',
  'applications.initializeSuccess': '应用初始化成功',
  'applications.deleteConfirmTitle': '删除应用',
  'applications.deleteConfirmDescription':
    '确定要删除此应用吗？此操作无法撤销。',
  'applications.searchPlaceholder': '按名称搜索应用...',
  'applications.allTenants': '所有租户',
  'applications.allStatuses': '所有状态',
  'applications.notFound': '未找到应用',
  'applications.name': '应用名称',
  'applications.type': '类型',
  'applications.logo': 'Logo',
  'applications.domains': '域名',
  'applications.id': 'ID',
  'applications.secret': '密钥',
  'applications.tenant': '所属租户',
  'applications.status': '状态',
  'applications.createdAt': '创建时间',
  'applications.updatedAt': '更新时间',
  'applications.resource': '关联资源',
  'applications.namePlaceholder': '请输入应用名称',
  'applications.typePlaceholder': '请输入应用类型',
  'applications.logoPlaceholder': '请输入 Logo 图片地址',
  'applications.logoHelpText': '输入应用 Logo 的有效 URL',
  'applications.logoPreview': 'Logo 预览',
  'applications.secretPlaceholder': '请输入密钥（可选，系统自动生成）',
  'applications.resourcePlaceholder': '请选择关联资源（可选）',
  'applications.tenantPlaceholder': '请选择所属租户',
  'applications.selectTenant': '选择租户',
  'applications.basicInformation': '基本信息',
  'applications.domainConfiguration': '域名配置',
  'applications.initialize': '初始化',
  'applications.initializeTitle': '初始化应用',
  'applications.initializeDescription': '从资源模板初始化此应用',
  'applications.secretWarning':
    '⚠️ 重要提示：请保存上面显示的应用密钥，出于安全考虑，它不会再次显示。',
  'applications.copySecret': '复制密钥',
  'applications.secretCopied': '密钥已复制到剪贴板',
  'applications.statusOptions.active': '启用',
  'applications.statusOptions.inactive': '停用',
  'applications.typeOptions.web': 'Web 应用',
  'applications.typeOptions.mobile': '移动应用',
  'applications.typeOptions.desktop': '桌面应用',
  'applications.typeOptions.api': 'API 服务',

  // ============== dashboard 仪表盘 ==============
  'dashboard.title': '仪表盘',
  'dashboard.description': '系统概览及统计信息',
  'dashboard.welcome': '欢迎使用资源管理系统',
  'dashboard.overview': '系统概览',
  'dashboard.statistics': '统计信息',
  'dashboard.totalTenants': '租户总数',
  'dashboard.totalApplications': '应用总数',
  'dashboard.activeTenants': '活跃租户',
  'dashboard.inactiveTenants': '停用租户',
  'dashboard.activeApplications': '活跃应用',
  'dashboard.inactiveApplications': '停用应用',
  'dashboard.recentApplications': '最近创建的应用',
  'dashboard.recentApplicationsDescription': '最近创建的应用列表',
  'dashboard.noRecentApplications': '暂无最近创建的应用',
  'dashboard.viewAll': '查看全部',
  'dashboard.lastUpdated': '最后更新',
  'dashboard.error.title': '加载仪表盘失败',
  'dashboard.error.noData': '暂无数据',
  'dashboard.error.retry': '重试',
  'dashboard.error.description': '无法加载仪表盘数据，请重试。',

  // ============== welcome 欢迎页 ==============
  'welcome.title': '资源管理系统',
  'welcome.description': '多租户 SaaS 平台资源配置管理界面',

  // ============== inactiveTenants 长期未登录租户提醒 ==============
  'inactiveTenants.title': '长期未登录租户提醒',
  'inactiveTenants.description': '管理长期未活跃的租户，发送提醒通知',
  'inactiveTenants.ownerEmail': '所有者邮箱',
  'inactiveTenants.ownerPhone': '所有者手机',
  'inactiveTenants.lastActiveAt': '最后活跃时间',
  'inactiveTenants.inactiveDays': '不活跃天数',
  'inactiveTenants.remindCount': '提醒次数',
  'inactiveTenants.lastRemindAt': '上次提醒时间',
  'inactiveTenants.statusNormal': '正常',
  'inactiveTenants.statusWarning': '预警',
  'inactiveTenants.statusAttention': '需关注',
  'inactiveTenants.sendReminder': '发送提醒',
  'inactiveTenants.remind': '提醒',
  'inactiveTenants.viewHistory': '提醒历史',
  'inactiveTenants.config': '提醒配置',
  'inactiveTenants.configTitle': '提醒配置',
  'inactiveTenants.inactiveDaysThreshold': '不活跃天数阈值',
  'inactiveTenants.inactiveDaysThresholdHelp':
    '超过此天数未活跃的租户将出现在列表中',
  'inactiveTenants.remindIntervalDays': '提醒间隔天数',
  'inactiveTenants.remindIntervalDaysHelp':
    '同一租户两次提醒之间的最小间隔天数',
  'inactiveTenants.maxRemindCount': '最大提醒次数',
  'inactiveTenants.maxRemindCountHelp': '超过此次数后不再发送提醒',
  'inactiveTenants.remindSuccess': '提醒发送成功',
  'inactiveTenants.batchRemindSuccess': '批量提醒发送成功，共发送 {count} 条',
  'inactiveTenants.batchRemind': '批量发送提醒',
  'inactiveTenants.selectedCount': '已选择 {count} 个租户',
  'inactiveTenants.selectAtLeastOne': '请至少选择一个租户',
  'inactiveTenants.remindHistoryTitle': '{name} 的提醒历史',
  'inactiveTenants.sendSuccess': '发送成功',
  'inactiveTenants.sendFailed': '发送失败',
  'inactiveTenants.noRemindHistory': '暂无提醒记录',

  // ============== navigation 导航 ==============
  'navigation.home': '首页',
  'navigation.dashboard': '仪表盘',
  'navigation.tenants': '租户管理',
  'navigation.applications': '应用管理',
  'navigation.resources': '资源管理',
  'navigation.resourceTypes': '资源类型',
  'navigation.menus': '菜单管理',
  'navigation.roles': '角色管理',
  'navigation.settings': '设置',

  // ============== resource.config 资源配置 ==============
  'resource.config.title': '资源配置',
  'resource.config.list': '配置列表',
  'resource.config.create': '新建配置',
  'resource.config.edit': '编辑配置',
  'resource.config.key': '配置键',
  'resource.config.value': '配置值',
  'resource.config.scope': '可见范围',
  'resource.config.remark': '备注',
  'resource.config.manage': '管理配置',
};
